import React, { Fragment, useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { Card, Col, Container, Row } from "reactstrap";
import { Icon } from "@progress/kendo-react-common";
import ErrorBoundary from "../../ErrorBoundry";
import { advanceSearch } from "../../_helper/services/advanceSearchv2";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { loadingPanel } from "../../CommonComponents/CommonFunction";

function BenefitStatistics() {
  const options = {
    chart: {
      type: "pie",
      events: {
        drilldown: function (e) {
          this.update({
            drilldown: {
              breadcrumbs: {
                position: {
                  align: "left",
                },
              },
            },
          });
        },
        drillup: function (e) {
          this.update({
            drilldown: {
              breadcrumbs: {
                position: {
                  align: "left",
                },
              },
            },
          });
        },
      },
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
      point: {
        valueSuffix: "",
      },
    },

    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        showInLegend: true,
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}:{point.y}</b>",
        },
      },
      series: {
        borderRadius: 5,
        // dataLabels: [
        //   {
        //     enabled: true,
        //     distance: 15,
        //     format: "{point.name}",
        //   },
        //   {
        //     enabled: true,
        //     distance: "-30%",
        //     filter: {
        //       property: "percentage",
        //       operator: ">",
        //       value: 5,
        //     },
        //     format: "{point.y:.1f}%",
        //     style: {
        //       fontSize: "0.9em",
        //       textOutline: "none",
        //     },
        //   },
        // ],
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: ' +
        "<b>{point.y}</b><br/>",
    },
  };
  const [optionDental, setOptionsDental] = useState(options);
  const [optionHealth, setOptionsHealth] = useState(options);
  const [isDentalLoading, setIsDentalLoading] = useState(false);
  const [isHealthLoading, setIsHealthLoading] = useState(false);

  const getHealthData = async () => {
    setIsHealthLoading(true);
    const payload = {
      tableName: "vw_benefit_health_statistics",
      searchParams: "[]",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000,
      sortData: "",
      additionalWhere: "",
      location: "Benefits-global",
    };
    try {
      const response = await advanceSearch(payload, "Benefits");
      const { results } = response;
      const compnayAarray = results
        .filter((i) => !i.code && !i.class)
        .map((item) => {
          return {
            name: item.vendor,
            y: item.total,
            drilldown: item.vendor,
            code: item.code,
          };
        });
      const compnayDrillDown = compnayAarray.map((item) => {
        return {
          id: item.name,
          name: item.name,
          data: results
            .filter((i) => i.code && !i.class && i.vendor == item.name)
            .map((i) => {
              return {
                name: i.code,
                y: i.total,
                drilldown: i.vendor + "-" + i.code,
              };
            }),
          // drilldown:
        };
      });
      const otherDilldown = results
        .filter((i) => i.code && !i.class)
        .map((item) => {
          return {
            id: item.vendor + "-" + item.code,
            name: "Deduction Class",
            data: results
              .filter(
                (i) =>
                  i.code &&
                  i.class &&
                  i.vendor == item.vendor &&
                  i.code == item.code
              )
              .map((i) => {
                return { name: i.class, y: i.total };
              }),
          };
        });
      setOptionsHealth({
        ...optionHealth,
        title: {
          text: "Health Statistics",
          align: "center",
        },
        series: [
          {
            name: "Company",
            colorByPoint: true,
            data: compnayAarray,
          },
        ],
        drilldown: {
          breadcrumbs: {
            // floating: true,
            position: {
              align: "left",
            },
          },
          series: [...compnayDrillDown, ...otherDilldown],
        },
      });
      // setRowCount(rowCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsHealthLoading(false);
      // setLoading(false);
    }
  };
  const getDentalData = async () => {
    setIsDentalLoading(true);
    const payload = {
      tableName: "vw_benefit_dental_statistics",
      searchParams: "[]",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000,
      sortData: "",
      additionalWhere: "",
      location: "Benefits-global",
    };
    try {
      const response = await advanceSearch(payload, "Benefits");
      const { results } = response;
      const compnayAarray = results
        .filter((i) => !i.code && !i.class)
        .map((item) => {
          return {
            name: item.vendor,
            y: item.total,
            drilldown: item.vendor,
            code: item.code,
          };
        });
      const compnayDrillDown = compnayAarray.map((item) => {
        return {
          id: item.name,
          name: item.name,
          data: results
            .filter((i) => i.code && !i.class && i.vendor == item.name)
            .map((i) => {
              return {
                name: i.code,
                y: i.total,
                drilldown: i.vendor + "-" + i.code,
              };
            }),
          // drilldown:
        };
      });
      const otherDilldown = results
        .filter((i) => i.code && !i.class)
        .map((item) => {
          return {
            id: item.vendor + "-" + item.code,
            name: "Deduction Class",
            data: results
              .filter(
                (i) =>
                  i.code &&
                  i.class &&
                  i.vendor == item.vendor &&
                  i.code == item.code
              )
              .map((i) => {
                return { name: i.class, y: i.total };
              }),
          };
        });
      setOptionsDental({
        ...optionDental,
        title: {
          text: "Dental Statistics",
          align: "center",
        },
        series: [
          {
            name: "Company",
            colorByPoint: true,
            data: compnayAarray,
          },
        ],
        drilldown: {
          series: [...compnayDrillDown, ...otherDilldown],
        },
      });
      // setRowCount(rowCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsDentalLoading(false);

      // setLoading(false);
    }
  };

  useEffect(() => {
    getHealthData();
    getDentalData();
  }, []);

  return (
    <ErrorBoundary>
      {" "}
      <Fragment>
        {isDentalLoading || isHealthLoading ? loadingPanel() : null}
        <Container fluid={true}>
          <Row className="bg-primary rounded py-3 mb-3">
            <Col md={6}>
              <Typography variant="h5">
                <Icon
                  style={{ fontSize: "25px", margin: "10px" }}
                  name="graph"
                />
                Benefits Analysis
              </Typography>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Card className="p-3">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionHealth}
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="p-3">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionDental}
                />
              </Card>
            </Col>
          </Row>
          <Row></Row>
        </Container>
      </Fragment>
    </ErrorBoundary>
  );
}
export default BenefitStatistics;
